import { render } from "./ViewItemComponent2.vue?vue&type=template&id=12ed0a06"
import script from "./ViewItemComponent2.vue?vue&type=script&lang=js"
export * from "./ViewItemComponent2.vue?vue&type=script&lang=js"
script.render = render

export default script